import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=5275b940&scoped=true"
import script from "./WelcomeModal.vue?vue&type=script&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&lang=js"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&id=5275b940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275b940",
  null
  
)

export default component.exports